import 'svelte/internal/disclose-version';

Admin[$.FILENAME] = 'src/pages/Admin.svelte';

import * as $ from 'svelte/internal/client';
import api from "../lib/api.js";
import EmptyState from "../components/EmptyState.svelte";
import AdminNav from "../components/AdminNav.svelte";
import { session } from "../lib/session.svelte.js";
import { formatLocation, priceLabel, relativeTime } from "../lib/format.js";
import { toastError, toastSuccess } from "../lib/toast.svelte.js";

var root = $.add_locations($.from_html(`<div class="stats svelte-1jknolv"><div class="svelte-1jknolv"><b class="svelte-1jknolv"> </b><span class="svelte-1jknolv">restaurants</span></div> <div class="svelte-1jknolv"><b class="svelte-1jknolv"> </b><span class="svelte-1jknolv">accounts</span></div> <div class="svelte-1jknolv"><b class="svelte-1jknolv"> </b><span class="svelte-1jknolv">reviews</span></div> <div class="svelte-1jknolv"><b class="svelte-1jknolv"> </b><span class="svelte-1jknolv">admins</span></div></div>`), Admin[$.FILENAME], [
	[
		168,
		4,
		[
			[169, 6, [[169, 11], [169, 37]]],
			[170, 6, [[170, 11], [170, 31]]],
			[171, 6, [[171, 11], [171, 33]]],
			[172, 6, [[172, 11], [172, 32]]]
		]
	]
]);

var root_1 = $.add_locations($.from_html(`<div class="progress svelte-1jknolv" role="progressbar" aria-valuemin="0" aria-valuemax="100"><div class="bar svelte-1jknolv"></div></div> <p class="status svelte-1jknolv"> <span class="muted svelte-1jknolv"> </span></p>`, 1), Admin[$.FILENAME], [[190, 8, [[191, 10]]], [193, 8, [[195, 10]]]]);
var root_2 = $.add_locations($.from_html(`<p class="status muted svelte-1jknolv"> </p>`), Admin[$.FILENAME], [[201, 8]]);
var root_3 = $.add_locations($.from_html(`<p class="status svelte-1jknolv"><strong> </strong> <span class="muted svelte-1jknolv"> <!> </span></p> <button class="primary svelte-1jknolv"> </button>`, 1), Admin[$.FILENAME], [[205, 8, [[206, 10], [208, 10]]], [218, 8]]);
var root_4 = $.add_locations($.from_html(`<div><!></div>`), Admin[$.FILENAME], [[188, 4]]);
var root_5 = $.add_locations($.from_html(`<p class="muted svelte-1jknolv">Loading…</p>`), Admin[$.FILENAME], [[226, 4]]);
var root_6 = $.add_locations($.from_html(`<span class="tag warn svelte-1jknolv">unmatched</span>`), Admin[$.FILENAME], [[249, 14]]);
var root_7 = $.add_locations($.from_html(`<button class="danger svelte-1jknolv">Really delete</button> <button class="svelte-1jknolv">Cancel</button>`, 1), Admin[$.FILENAME], [[266, 14], [267, 14]]);
var root_8 = $.add_locations($.from_html(`<button class="danger-link svelte-1jknolv">Delete</button>`), Admin[$.FILENAME], [[269, 14]]);

var root_9 = $.add_locations($.from_html(`<li class="svelte-1jknolv"><div class="cell name svelte-1jknolv"><a class="svelte-1jknolv"> </a> <span class="sub svelte-1jknolv"> </span></div> <div class="cell"> </div> <div class="cell"> </div> <div class="cell media svelte-1jknolv"><span> </span> <span> </span> <!></div> <div class="cell muted svelte-1jknolv"> </div> <div class="cell actions svelte-1jknolv"><a class="svelte-1jknolv">View</a> <a class="svelte-1jknolv">Edit</a> <button class="svelte-1jknolv"> </button> <!></div></li>`), Admin[$.FILENAME], [
	[
		233,
		8,
		[
			[234, 10, [[235, 12], [236, 12]]],
			[238, 10],
			[239, 10],
			[240, 10, [[241, 12], [244, 12]]],
			[252, 10],
			[253, 10, [[254, 12], [255, 12], [256, 12]]]
		]
	]
]);

var root_10 = $.add_locations($.from_html(`<div class="pager svelte-1jknolv"><button class="svelte-1jknolv">← Previous</button> <span> </span> <button class="svelte-1jknolv">Next →</button></div>`), Admin[$.FILENAME], [[277, 6, [[278, 8], [279, 8], [280, 8]]]]);
var root_11 = $.add_locations($.from_html(`<ul class="rows svelte-1jknolv"></ul> <!>`, 1), Admin[$.FILENAME], [[231, 4]]);
var root_12 = $.add_locations($.from_html(`<!> <!> <div class="toolbar svelte-1jknolv"><input type="search" placeholder="Filter restaurants…" aria-label="Filter restaurants" class="svelte-1jknolv"/> <a class="primary svelte-1jknolv" href="/admin/restaurants/new">+ Add restaurant</a></div> <!> <!>`, 1), Admin[$.FILENAME], [[176, 2, [[177, 4], [184, 4]]]]);

const $$css = {
	hash: 'svelte-1jknolv',
	code: '\n  /* Media refresh bar — sits above the table so a stale catalogue is visible without scrolling. */\n  .media-bar.svelte-1jknolv {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex-wrap: wrap;\n    padding: 0.75rem 1rem;\n    margin-bottom: 1rem;\n    border: 1px solid var(--border);\n    border-radius: 8px;\n    background: var(--surface-2, rgba(127, 127, 127, 0.06));\n  }\n  .media-bar.svelte-1jknolv .status:where(.svelte-1jknolv) {\n    margin: 0;\n    flex: 1 1 20rem;\n    font-size: 0.9rem;\n    line-height: 1.5;\n  }\n  .media-bar.svelte-1jknolv .status:where(.svelte-1jknolv) .muted:where(.svelte-1jknolv) {\n    display: block;\n    font-size: 0.82rem;\n  }\n  .media-bar.svelte-1jknolv .progress:where(.svelte-1jknolv) {\n    flex: 1 1 100%;\n    height: 6px;\n    border-radius: 999px;\n    overflow: hidden;\n    background: var(--border);\n  }\n  .media-bar.svelte-1jknolv .progress:where(.svelte-1jknolv) .bar:where(.svelte-1jknolv) {\n    height: 100%;\n    background: var(--accent, #3b82f6);\n    transition: width 0.3s ease;\n  }\n\n  .stats.svelte-1jknolv {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n    gap: 12px;\n    margin-bottom: 22px;\n  }\n  .stats.svelte-1jknolv div:where(.svelte-1jknolv) {\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n    padding: 16px 18px;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n  .stats.svelte-1jknolv b:where(.svelte-1jknolv) { font-size: 1.6rem; font-family: var(--font); }\n  .stats.svelte-1jknolv span:where(.svelte-1jknolv) { font-size: 0.8rem; color: var(--ink-faint); }\n\n  .toolbar.svelte-1jknolv { display: flex; gap: 12px; margin-bottom: 18px; flex-wrap: wrap; }\n  .toolbar.svelte-1jknolv input:where(.svelte-1jknolv) {\n    flex: 1;\n    min-width: 200px;\n    background: var(--card);\n    border: 1px solid var(--line-strong);\n    border-radius: var(--radius-pill);\n    padding: 11px 18px;\n    font-size: 0.92rem;\n    outline: none;\n  }\n  .toolbar.svelte-1jknolv input:where(.svelte-1jknolv):focus { border-color: var(--accent); box-shadow: 0 0 0 3px var(--accent-soft); }\n  .primary.svelte-1jknolv {\n    background: var(--accent);\n    color: #fff;\n    font-weight: 600;\n    font-size: 0.9rem;\n    padding: 11px 20px;\n    border-radius: var(--radius-pill);\n    white-space: nowrap;\n  }\n  .primary.svelte-1jknolv:hover { background: var(--accent-dark); }\n\n  .rows.svelte-1jknolv { list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 8px; }\n  .rows.svelte-1jknolv li:where(.svelte-1jknolv) {\n    display: grid;\n    grid-template-columns: 2.2fr 0.6fr 0.9fr 1.2fr 1fr auto;\n    align-items: center;\n    gap: 14px;\n    background: var(--card);\n    border: 1px solid var(--line);\n    border-radius: var(--radius);\n    padding: 13px 18px;\n    font-size: 0.9rem;\n  }\n  .name.svelte-1jknolv { display: flex; flex-direction: column; gap: 2px; min-width: 0; }\n  .name.svelte-1jknolv a:where(.svelte-1jknolv) { font-weight: 600; }\n  .name.svelte-1jknolv a:where(.svelte-1jknolv):hover { color: var(--accent); }\n  .sub.svelte-1jknolv { font-size: 0.8rem; color: var(--ink-faint); }\n  .muted.svelte-1jknolv { color: var(--ink-faint); font-size: 0.84rem; }\n\n  .actions.svelte-1jknolv { display: flex; gap: 10px; align-items: center; justify-content: flex-end; }\n  .actions.svelte-1jknolv a:where(.svelte-1jknolv) { color: var(--ink-soft); font-size: 0.85rem; }\n  .actions.svelte-1jknolv a:where(.svelte-1jknolv):hover { color: var(--accent); text-decoration: underline; }\n  .actions.svelte-1jknolv button:where(.svelte-1jknolv) {\n    border: none;\n    background: none;\n    cursor: pointer;\n    font-size: 0.85rem;\n    color: var(--ink-soft);\n  }\n  .danger-link.svelte-1jknolv { color: var(--accent-dark) !important; }\n  .danger.svelte-1jknolv {\n    background: var(--accent) !important;\n    color: #fff !important;\n    padding: 5px 12px;\n    border-radius: var(--radius-pill);\n  }\n\n  .pager.svelte-1jknolv { display: flex; align-items: center; justify-content: center; gap: 18px; margin-top: 26px; font-size: 0.88rem; }\n  .pager.svelte-1jknolv button:where(.svelte-1jknolv) {\n    border: 1px solid var(--line-strong);\n    background: var(--card);\n    border-radius: var(--radius-pill);\n    padding: 8px 16px;\n    cursor: pointer;\n  }\n  .pager.svelte-1jknolv button:where(.svelte-1jknolv):disabled { opacity: 0.4; cursor: default; }\n\n  @media (max-width: 820px) {\n    .rows.svelte-1jknolv li:where(.svelte-1jknolv) { grid-template-columns: 1fr; gap: 8px; }\n    .actions.svelte-1jknolv { justify-content: flex-start; padding-top: 4px; border-top: 1px solid var(--line); }\n  }\n  .media.svelte-1jknolv { display: flex; gap: 6px; flex-wrap: wrap; }\n  .tag.svelte-1jknolv {\n    font-size: 0.72rem;\n    font-weight: 600;\n    padding: 2px 8px;\n    border-radius: var(--radius-pill);\n    border: 1px solid var(--line);\n    color: var(--ink-soft);\n    white-space: nowrap;\n  }\n  .tag.on.svelte-1jknolv { border-color: var(--accent); color: var(--accent); }\n  .tag.warn.svelte-1jknolv { border-style: dashed; }\n\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
};

export default function Admin($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Admin);
	$.append_styles($$anchor, $$css);

	let stats = $.tag($.state(null), 'stats');
	let page = $.tag($.state(1), 'page');
	let query = $.tag($.state(""), 'query');
	let data = $.tag($.state(null), 'data');
	let loading = $.tag($.state(true), 'loading');
	let pendingDelete = $.tag($.state(null), 'pendingDelete');
	let ingesting = $.tag($.state(null), 'ingesting');
	let media = $.tag($.state(null // { stale, maxAgeDays, retentionDays }
	), 'media');
	let mediaJob = $.tag($.state(null // live status while a pass runs
	), 'mediaJob');
	let startingMedia = $.tag($.state(false), 'startingMedia');
	let mediaPoll = null;

	async function loadStaleMedia() {
		try {
			$.set(media, (await $.track_reactivity_loss(api.staleMedia()))(), true);
		} catch {
			// A server without ingest configured answers 400 here. The button just stays hidden;
			// the ingest page is where that gets explained properly.
			$.set(media, null);
		}
	}

	async function refreshAllMedia() {
		$.set(startingMedia, true);

		try {
			$.set(mediaJob, (await $.track_reactivity_loss(api.refreshMedia($.get(media).maxAgeDays, $.get(media).limit)))(), true);
			pollMedia();
		} catch(error) {
			toastError(error.message ?? "Couldn't start the media refresh.");
		} finally {
			$.set(startingMedia, false);
		}
	}

	function pollMedia() {
		clearInterval(mediaPoll);

		mediaPoll = setInterval(
			async () => {
				try {
					const status = (await $.track_reactivity_loss(api.ingestStatus()))();

					$.set(mediaJob, status.status, true);

					if (!status.status.running) {
						clearInterval(mediaPoll);
						mediaPoll = null;

						const outcome = status.status.outcome;

						if (outcome) {
							toastSuccess(`Media refresh: ${outcome.refreshed} restaurant(s), ${outcome.photosCached} photo(s), ` + `${outcome.apiCalls} API call(s).`);
						}

						if (status.status.error) toastError(status.status.error);

						(await $.track_reactivity_loss(Promise.all([loadStaleMedia(), reloadPage()])))();
					}
				} catch(error) {
					clearInterval(mediaPoll);
					mediaPoll = null;
					toastError(error.message ?? "Lost track of the media refresh.");
				}
			},
			1500
		);
	}

	async function reloadPage() {
		const params = new URLSearchParams({ page: String($.get(page)), pageSize: "20" });

		if ($.get(query).trim()) params.set("q", $.get(query).trim());

		$.set(data, (await $.track_reactivity_loss(api.adminRestaurants(params)))(), true);
	}

	async function ingestOne(restaurant) {
		$.set(ingesting, restaurant.id, true);

		try {
			const outcome = (await $.track_reactivity_loss(api.ingestRestaurant(restaurant.id)))();

			// Replace the row in place rather than reloading the page — a full reload would lose the
			// reviewer's scroll position halfway down a 500-row table. The bar's stale count is a
			// separate fetch, so it needs its own refresh or it keeps reporting pre-fetch numbers.
			const stats = (await $.track_reactivity_loss(api.adminRestaurants(new URLSearchParams({ page: String($.get(page)), pageSize: "25" }))))();

			$.set(data, stats, true);
			(await $.track_reactivity_loss(loadStaleMedia()))();
			toastSuccess(`${restaurant.name}: ${outcome.photosCached} photo(s), ${outcome.excerptsCached} excerpt(s), ` + `${outcome.apiCalls} API call(s).`);
		} catch(error) {
			toastError(error.message ?? "Couldn't fetch media for that restaurant.");
		} finally {
			$.set(ingesting, null);
		}
	}

	const isAdmin = $.tag($.derived(() => $.strict_equals(session.user?.role, "admin")), 'isAdmin');
	const mediaRunning = $.tag($.derived(() => $.get(mediaJob)?.running && $.strict_equals($.get(mediaJob)?.kind, "media")), 'mediaRunning');
	const batchSize = $.tag($.derived(() => $.get(media) ? Math.min($.get(media).stale, $.get(media).limit) : 0), 'batchSize');

	const mediaProgress = $.tag(
		$.derived(() => $.get(mediaRunning) && $.get(mediaJob)?.progress?.total
			? Math.round($.get(mediaJob).progress.done / $.get(mediaJob).progress.total * 100)
			: 0),
		'mediaProgress'
	);

	$.user_effect(() => {
		if (!$.get(isAdmin)) return;

		loadStaleMedia();

		// A pass started from another tab (or a reload mid-run) should still show progress here.
		api.ingestStatus().then((s) => {
			if (s.status.running && $.strict_equals(s.status.kind, "media")) {
				$.set(mediaJob, s.status, true);
				pollMedia();
			}
		}).catch(() => {});

		return () => clearInterval(mediaPoll);
	});

	$.user_effect(() => {
		if (!$.get(isAdmin)) return;

		api.adminStats().then((s) => $.set(stats, s, true)).catch(() => {});
	});

	$.user_effect(() => {
		if (!$.get(isAdmin)) return;

		const params = new URLSearchParams({ page: String($.get(page)), pageSize: "20" });

		if ($.get(query).trim()) params.set("q", $.get(query).trim());

		let cancelled = false;

		$.set(loading, true);

		api.adminRestaurants(params).then((response) => {
			if (!cancelled) $.set(data, response, true);
		}).catch((error) => !cancelled && toastError(error.message)).finally(() => {
			if (!cancelled) $.set(loading, false);
		});

		return () => {
			cancelled = true;
		};
	});

	async function confirmDelete(restaurant) {
		try {
			(await $.track_reactivity_loss(api.deleteRestaurant(restaurant.id)))();

			$.set(
				data,
				{
					...$.get(data),
					items: $.get(data).items.filter((r) => $.strict_equals(r.id, restaurant.id, false)),
					total: $.get(data).total - 1
				},
				true
			);

			$.set(
				stats,
				$.get(stats)
					? { ...$.get(stats), restaurants: $.get(stats).restaurants - 1 }
					: $.get(stats),
				true
			);

			toastSuccess(`Removed ${restaurant.name}.`);
		} catch(error) {
			toastError(error.message ?? "Couldn't remove that.");
		} finally {
			$.set(pendingDelete, null);
		}
	}

	const pageCount = $.tag($.derived(() => Math.max(1, Math.ceil(($.get(data)?.total ?? 0) / ($.get(data)?.pageSize ?? 20)))), 'pageCount');
	var $$exports = { ...$.legacy_api() };
	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_1 = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_1 = $.first_child(fragment_1);

			{
				var consequent = ($$anchor) => {
					$.add_svelte_meta(
						() => EmptyState($$anchor, {
							icon: '🔒',
							title: 'Admins only',
							message: 'This area manages restaurants and accounts.',
							action: { href: "/", label: "Back home" }
						}),
						'component',
						Admin,
						162,
						4,
						{ componentTag: 'EmptyState' }
					);
				};

				$.add_svelte_meta(
					() => $.if(node_1, ($$render) => {
						if (session.loaded) $$render(consequent);
					}),
					'if',
					Admin,
					161,
					2
				);
			}

			$.append($$anchor, fragment_1);
		};

		var alternate_3 = ($$anchor) => {
			var fragment_3 = root_12();
			var node_2 = $.first_child(fragment_3);

			$.add_svelte_meta(() => AdminNav(node_2, { current: 'restaurants' }), 'component', Admin, 165, 2, { componentTag: 'AdminNav' });

			var node_3 = $.sibling(node_2, 2);

			{
				var consequent_2 = ($$anchor) => {
					var div = root();
					var div_1 = $.child(div);
					var b = $.child(div_1);
					var text = $.child(b, true);

					$.reset(b);
					$.next();
					$.reset(div_1);

					var div_2 = $.sibling(div_1, 2);
					var b_1 = $.child(div_2);
					var text_1 = $.child(b_1, true);

					$.reset(b_1);
					$.next();
					$.reset(div_2);

					var div_3 = $.sibling(div_2, 2);
					var b_2 = $.child(div_3);
					var text_2 = $.child(b_2, true);

					$.reset(b_2);
					$.next();
					$.reset(div_3);

					var div_4 = $.sibling(div_3, 2);
					var b_3 = $.child(div_4);
					var text_3 = $.child(b_3, true);

					$.reset(b_3);
					$.next();
					$.reset(div_4);
					$.reset(div);

					$.template_effect(() => {
						$.set_text(text, $.get(stats).restaurants);
						$.set_text(text_1, $.get(stats).users);
						$.set_text(text_2, $.get(stats).reviews);
						$.set_text(text_3, $.get(stats).admins);
					});

					$.append($$anchor, div);
				};

				$.add_svelte_meta(
					() => $.if(node_3, ($$render) => {
						if ($.get(stats)) $$render(consequent_2);
					}),
					'if',
					Admin,
					167,
					2
				);
			}

			var div_5 = $.sibling(node_3, 2);
			var input = $.child(div_5);

			$.remove_input_defaults(input);
			$.next(2);
			$.reset(div_5);

			var node_4 = $.sibling(div_5, 2);

			{
				var consequent_6 = ($$anchor) => {
					var div_6 = root_4();
					let classes;
					var node_5 = $.child(div_6);

					{
						var consequent_3 = ($$anchor) => {
							var fragment_4 = root_1();
							var div_7 = $.first_child(fragment_4);
							var div_8 = $.child(div_7);

							$.reset(div_7);

							var p = $.sibling(div_7, 2);
							var text_4 = $.child(p);
							var span = $.sibling(text_4);
							var text_5 = $.child(span);

							$.reset(span);
							$.reset(p);

							$.template_effect(() => {
								$.set_attribute(div_7, 'aria-valuenow', $.get(mediaProgress));
								$.set_style(div_8, `width: ${$.get(mediaProgress) ?? ''}%`);
								$.set_text(text_4, `${$.get(mediaJob).progress?.detail ?? "Starting…" ?? ''} `);

								$.set_text(text_5, `${$.get(mediaJob).progress?.done ?? 0 ?? ''}/${$.get(mediaJob).progress?.total ?? "?" ?? ''} ·
            ${$.get(mediaJob).progress?.apiCalls ?? 0 ?? ''} API calls`);
							});

							$.append($$anchor, fragment_4);
						};

						var consequent_4 = ($$anchor) => {
							var p_1 = root_2();
							var text_6 = $.child(p_1);

							$.reset(p_1);
							$.template_effect(() => $.set_text(text_6, `All media is current — nothing fetched more than ${$.get(media).maxAgeDays ?? ''} days ago.`));
							$.append($$anchor, p_1);
						};

						var alternate = ($$anchor) => {
							var fragment_5 = root_3();
							var p_2 = $.first_child(fragment_5);
							var strong = $.child(p_2);
							var text_7 = $.child(strong, true);

							$.reset(strong);

							var text_8 = $.sibling(strong);
							var span_1 = $.sibling(text_8);
							var text_9 = $.child(span_1);
							var node_6 = $.sibling(text_9);

							{
								var consequent_5 = ($$anchor) => {
									var text_10 = $.text('Run it again for the rest.');

									$.append($$anchor, text_10);
								};

								$.add_svelte_meta(
									() => $.if(node_6, ($$render) => {
										if ($.get(media).stale > $.get(media).limit) $$render(consequent_5);
									}),
									'if',
									Admin,
									211,
									12
								);
							}

							var text_11 = $.sibling(node_6);

							$.reset(span_1);
							$.reset(p_2);

							var button = $.sibling(p_2, 2);
							var text_12 = $.child(button, true);

							$.reset(button);

							$.template_effect(() => {
								$.set_text(text_7, $.get(media).stale);

								$.set_text(text_8, ` restaurant${$.strict_equals($.get(media).stale, 1) ? " has" : "s have"}
          media that is missing or older than ${$.get(media).maxAgeDays ?? ''} days. `);

								$.set_text(text_9, `This press covers ${$.get(batchSize) ?? ''} of them — about ${$.get(batchSize) * $.get(media).callsPerRestaurant}
            Google calls. `);

								$.set_text(text_11, ` Provider photos are deleted after ${$.get(media).retentionDays ?? ''} days, so refreshing before then
            is what keeps them on the site.`);

								button.disabled = $.get(startingMedia);
								$.set_text(text_12, $.get(startingMedia) ? "Starting…" : `Fetch media for ${$.get(batchSize)}`);
							});

							$.delegated('click', button, refreshAllMedia);
							$.append($$anchor, fragment_5);
						};

						$.add_svelte_meta(
							() => $.if(node_5, ($$render) => {
								if ($.get(mediaRunning)) $$render(consequent_3); else if ($.strict_equals($.get(media).stale, 0)) $$render(consequent_4, 1); else $$render(alternate, -1);
							}),
							'if',
							Admin,
							189,
							6
						);
					}

					$.reset(div_6);
					$.template_effect(() => classes = $.set_class(div_6, 1, 'media-bar svelte-1jknolv', null, classes, { running: $.get(mediaRunning) }));
					$.append($$anchor, div_6);
				};

				$.add_svelte_meta(
					() => $.if(node_4, ($$render) => {
						if ($.get(media)) $$render(consequent_6);
					}),
					'if',
					Admin,
					187,
					2
				);
			}

			var node_7 = $.sibling(node_4, 2);

			{
				var consequent_7 = ($$anchor) => {
					var p_3 = root_5();

					$.append($$anchor, p_3);
				};

				var consequent_8 = ($$anchor) => {
					$.add_svelte_meta(
						() => EmptyState($$anchor, {
							icon: '🍽️',
							title: 'No restaurants yet',
							message: 'Add the first one — it takes about a minute.',
							action: { href: "/admin/restaurants/new", label: "Add restaurant" }
						}),
						'component',
						Admin,
						228,
						4,
						{ componentTag: 'EmptyState' }
					);
				};

				var alternate_2 = ($$anchor) => {
					var fragment_7 = root_11();
					var ul = $.first_child(fragment_7);

					$.add_svelte_meta(
						() => $.each(ul, 21, () => $.get(data).items, (restaurant) => restaurant.id, ($$anchor, restaurant) => {
							var li = root_9();
							var div_9 = $.child(li);
							var a = $.child(div_9);
							var text_13 = $.child(a, true);

							$.reset(a);

							var span_2 = $.sibling(a, 2);
							var text_14 = $.child(span_2);

							$.reset(span_2);
							$.reset(div_9);

							var div_10 = $.sibling(div_9, 2);
							var text_15 = $.child(div_10, true);

							$.reset(div_10);

							var div_11 = $.sibling(div_10, 2);
							var text_16 = $.child(div_11);

							$.reset(div_11);

							var div_12 = $.sibling(div_11, 2);
							var span_3 = $.child(div_12);
							let classes_1;
							var text_17 = $.child(span_3, true);

							$.reset(span_3);

							var span_4 = $.sibling(span_3, 2);
							let classes_2;
							var text_18 = $.child(span_4);

							$.reset(span_4);

							var node_8 = $.sibling(span_4, 2);

							{
								var consequent_9 = ($$anchor) => {
									var span_5 = root_6();

									$.append($$anchor, span_5);
								};

								$.add_svelte_meta(
									() => $.if(node_8, ($$render) => {
										if (!$.get(restaurant).providerLinked) $$render(consequent_9);
									}),
									'if',
									Admin,
									247,
									12
								);
							}

							$.reset(div_12);

							var div_13 = $.sibling(div_12, 2);
							var text_19 = $.child(div_13, true);

							$.reset(div_13);

							var div_14 = $.sibling(div_13, 2);
							var a_1 = $.child(div_14);
							var a_2 = $.sibling(a_1, 2);
							var button_1 = $.sibling(a_2, 2);
							var text_20 = $.child(button_1, true);

							$.reset(button_1);

							var node_9 = $.sibling(button_1, 2);

							{
								var consequent_10 = ($$anchor) => {
									var fragment_8 = root_7();
									var button_2 = $.first_child(fragment_8);
									var button_3 = $.sibling(button_2, 2);

									$.delegated('click', button_2, function click_1() {
										return confirmDelete($.get(restaurant));
									});

									$.delegated('click', button_3, function click_2() {
										return $.set(pendingDelete, null);
									});

									$.append($$anchor, fragment_8);
								};

								var alternate_1 = ($$anchor) => {
									var button_4 = root_8();

									$.delegated('click', button_4, function click_3() {
										return $.set(pendingDelete, $.get(restaurant).id, true);
									});

									$.append($$anchor, button_4);
								};

								$.add_svelte_meta(
									() => $.if(node_9, ($$render) => {
										if ($.strict_equals($.get(pendingDelete), $.get(restaurant).id)) $$render(consequent_10); else $$render(alternate_1, -1);
									}),
									'if',
									Admin,
									265,
									12
								);
							}

							$.reset(div_14);
							$.reset(li);

							$.template_effect(
								($0, $1, $2) => {
									$.set_attribute(a, 'href', `/admin/restaurants/${$.get(restaurant).id ?? ''}`);
									$.set_text(text_13, $.get(restaurant).name);
									$.set_text(text_14, `${$.get(restaurant).cuisine ?? ''} · ${$0 ?? ''}`);
									$.set_text(text_15, $1);
									$.set_text(text_16, `${$.get(restaurant).reviewCount ?? ''} reviews`);

									classes_1 = $.set_class(span_3, 1, 'tag svelte-1jknolv', null, classes_1, {
										on: $.get(restaurant).thumbnailUrl || $.get(restaurant).photoUrl
									});

									$.set_text(text_17, $.get(restaurant).thumbnailUrl
										? "thumb: own"
										: $.get(restaurant).photoUrl ? "thumb: provider" : "no thumb");

									classes_2 = $.set_class(span_4, 1, 'tag svelte-1jknolv', null, classes_2, { on: $.get(restaurant).photoCount > 0 });
									$.set_text(text_18, `${$.get(restaurant).photoCount ?? ''} image${$.strict_equals($.get(restaurant).photoCount, 1) ? "" : "s"}`);
									$.set_text(text_19, $2);
									$.set_attribute(a_1, 'href', `/r/${$.get(restaurant).slug ?? ''}`);
									$.set_attribute(a_2, 'href', `/admin/restaurants/${$.get(restaurant).id ?? ''}`);
									button_1.disabled = $.strict_equals($.get(ingesting), $.get(restaurant).id) || !$.get(restaurant).providerLinked;

									$.set_attribute(button_1, 'title', $.get(restaurant).providerLinked
										? "Fetch rating, reviews and photos from its Google listing"
										: "Not matched to a Google listing — added by hand, or Google's town search never returned it");

									$.set_text(text_20, $.strict_equals($.get(ingesting), $.get(restaurant).id) ? "Fetching…" : "Fetch media");
								},
								[
									() => formatLocation($.get(restaurant)),
									() => priceLabel($.get(restaurant).priceLevel),
									() => relativeTime($.get(restaurant).updatedAt)
								]
							);

							$.delegated('click', button_1, function click() {
								return ingestOne($.get(restaurant));
							});

							$.append($$anchor, li);
						}),
						'each',
						Admin,
						232,
						6
					);

					$.reset(ul);

					var node_10 = $.sibling(ul, 2);

					{
						var consequent_11 = ($$anchor) => {
							var div_15 = root_10();
							var button_5 = $.child(div_15);
							var span_6 = $.sibling(button_5, 2);
							var text_21 = $.child(span_6);

							$.reset(span_6);

							var button_6 = $.sibling(span_6, 2);

							$.reset(div_15);

							$.template_effect(() => {
								button_5.disabled = $.get(page) <= 1;
								$.set_text(text_21, `Page ${$.get(page) ?? ''} of ${$.get(pageCount) ?? ''}`);
								button_6.disabled = $.get(page) >= $.get(pageCount);
							});

							$.delegated('click', button_5, function click_4() {
								return $.set(page, $.get(page) - 1);
							});

							$.delegated('click', button_6, function click_5() {
								return $.set(page, $.get(page) + 1);
							});

							$.append($$anchor, div_15);
						};

						$.add_svelte_meta(
							() => $.if(node_10, ($$render) => {
								if ($.get(pageCount) > 1) $$render(consequent_11);
							}),
							'if',
							Admin,
							276,
							4
						);
					}

					$.append($$anchor, fragment_7);
				};

				$.add_svelte_meta(
					() => $.if(node_7, ($$render) => {
						if ($.get(loading) && !$.get(data)) $$render(consequent_7); else if (!$.get(data)?.items?.length) $$render(consequent_8, 1); else $$render(alternate_2, -1);
					}),
					'if',
					Admin,
					225,
					2
				);
			}

			$.delegated('input', input, function input_1() {
				return $.set(page, 1);
			});

			$.bind_value(
				input,
				function get() {
					return $.get(query);
				},
				function set($$value) {
					$.set(query, $$value);
				}
			);

			$.append($$anchor, fragment_3);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!$.get(isAdmin)) $$render(consequent_1); else $$render(alternate_3, -1);
			}),
			'if',
			Admin,
			160,
			0
		);
	}

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['input', 'click']);